import React, { Component } from 'react';
import config from 'config/config';
import { TPlatform } from '../../../components/preferences/single-sign-on/types/index';

type Props = {
  platform: TPlatform;
};

class SsoFaq extends Component<Props> {
  renderPlatformInformation(platform: TPlatform) {
    let information;
    switch (platform.value) {
      case 'piano':
        information = (
          <div className="sso-faq-links">
            <a href="https://docs.piano.io/piano-id-overview/#idcomponents" target="_blank">
              Getting your app credentials
            </a>
            <br />
            <a href="https://docs.piano.io/piano-id-overview/#sharedsecret" target="_blank">
              Getting your shared secret
            </a>
            <br />
            <a
              href="https://docs.piano.io/how-to-integrate-piano-id-with-commenting-apps/"
              target="_blank"
            >
              How to integrate Piano.io with commenting apps
            </a>
            <br />
          </div>
        );
        break;
      case 'janrain':
        information = (
          <div className="sso-faq-links">
            <a
              href="https://learn.akamai.com/en-us/webhelp/identity-cloud/technical-library/GUID-159EE914-9C35-4F82-AE18-52CE47223FD4.html"
              target="_blank"
            >
              Getting your app name
            </a>
            <br />
            <a
              href="https://learn.akamai.com/en-us/webhelp/identity-cloud/technical-library/GUID-E2EEA54D-D81E-439E-896A-4CD71E919D9C.html"
              target="_blank"
            >
              Getting your user token
            </a>
            <br />
          </div>
        );
        break;
      case 'auth0':
        information = (
          <div className="sso-faq-links">
            <a
              href="https://auth0.com/docs/custom-domains/auth0-managed-certificates#authentication-methods"
              target="_blank"
            >
              Getting your Auth0 domain
            </a>
            <br />
            <a href="https://auth0.com/docs/users/normalized/auth0/identify-users" target="_blank">
              Getting your resp prefix
            </a>
            <br />
            <a href="https://auth0.com/docs/api/authentication?http#get-user-info" target="_blank">
              Getting your user token
            </a>
            <br />
          </div>
        );
        break;
      case 'gigya':
        information = (
          <div className="sso-faq-links">
            <a href="https://developers.gigya.com/display/GD/accounts.login+REST" target="_blank">
              Getting your account details
            </a>
            <br />
          </div>
        );
        break;
      case 'other':
        return;
    }

    return (
      <React.Fragment>
        <div className="faq sso-faq">{platform.text}</div>
        <div className="faq-description">{information}</div>
      </React.Fragment>
    );
  }

  render() {
    const { platform } = this.props;
    return (
      <div className="faqs">
        <div className="faq">What is Single Sign On?</div>
        <div className="faq-description">
          <span>
            Single sign-on (SSO) is an authentication process that allows a user to access multiple
            applications with one set of login credentials.
            <br />
            SSO is a common procedure for publishers that own their user management process.
          </span>
        </div>
        <div className="faq sso-faq">Still have questions?</div>
        <div className="faq-description">
          <span>
            Visit our
            <a className="faq-link" href={config.api.urls.support} target="_blank">
              {' '}
              support{' '}
            </a>{' '}
            or
            <a className="faq-link" href={config.api.urls.developers} target="_blank">
              {' '}
              developers{' '}
            </a>{' '}
            sites or go ahead and
            <a className="faq-link" href={config.api.urls.contact} target="_blank">
              {' '}
              contact{' '}
            </a>
            our support team.
          </span>
        </div>
        {this.renderPlatformInformation(platform)}
      </div>
    );
  }
}

export default SsoFaq;
